//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/Select/Select.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import School from "@material-ui/icons/LocationCityOutlined";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

function Transition(props) {
    return <Slide direction="down" {...props} />;
  }
  
  class SchoolEditor extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        school: props.school
      };

      if(!this.state.school.Status)
        this.state.school.Status = "";
      if(!this.state.school.City)
        this.state.school.City = "";
      if(!this.state.school.State)
        this.state.school.State = "";
      if(!this.state.school.Website)
        this.state.school.Website = "";

      this.saveSchool = this.saveSchool.bind(this);
      this.updateSchool = this.updateSchool.bind(this);
    }

    handleClickOpen(modal) {
      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateSchool(property, value) {
      var obj = this.state.school;
      obj[property] = value;
      this.setState({school: obj});
    }

    saveSchool() {
    
      db.updateSchool(this.state.school.id, this.state.school).then(doc => {

        if(!this.state.school.id) { // i.e. if it's a new school

          this.updateSchool("id",doc.id);
          
          var school = this.state.school;
          school.id = doc.id;
          this.updateIntercom(school);

          ReactGA.event({
            category: 'School',
            action: 'Created a New School'
          });

          // reset to blank
          this.setState({school:{
            Name: "",
            Description: "",
            orgId: this.props.org.id,
            Status:"",
            id: null
          }});

        } else { // i.e. an existing school

          this.updateIntercom(this.state.school);

          ReactGA.event({
            category: 'School',
            action: 'Updated a School'
          });
        }
          
        this.props.onChange();
      });
    }

    updateIntercom(school) {

      var data = {
        "name": school.Name,
        "company_id": school.id,
        "status": school.Status,
        "website": school.Website
      }

      fetch("https://us-central1-keiki-262db.cloudfunctions.net/createCompany", {
        method: "POST", 
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then((response) => {
          if(response.ok) {
              return response.json()
          } else {
            console.log("save school to intercom error1");  
            console.log(response);
          }
      })
      .then((json) => {
  
      })
      .catch((error) => {
        // If there is any error you will catch them here
        console.log("error saving school to intercom: " + error);
      });
    }
        
    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit School</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: School,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={8}>
                            <CustomInput
                              labelText="Name"
                              value={this.state.school.Name}
                              inputProps={{
                                  placeholder: "Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomSelect
                                labelText="Status"
                                value={this.state.school.Status}
                                inputProps={{
                                    placeholder: "Status"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateSchool("Status", e.target.value)}
                                options={[
                                  {key:"active",label:"Active"},
                                  {key:"trial",label:"Trial"},
                                  {key:"lead",label:"Lead"},
                                  {key:"cancelled",label:"Cancelled"},
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              labelText="Street Address"
                              value={this.state.school.Address}
                              inputProps={{
                                  placeholder: "Street Address"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("Address", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              labelText="City"
                              value={this.state.school.City}
                              inputProps={{
                                  placeholder: "City"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("City", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                              labelText="State"
                              value={this.state.school.State}
                              inputProps={{
                                  placeholder: "State"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("State", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                              labelText="Postal Code"
                              value={this.state.school.PostalCode}
                              inputProps={{
                                  placeholder: "Postal Code"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("PostalCode", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              labelText="Website"
                              value={this.state.school.Website}
                              inputProps={{
                                  placeholder: "Website"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("Website", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              labelText="Login/Signup URL Modifier"
                              value={this.state.school.LoginPath}
                              inputProps={{
                                  placeholder: "Login/Signup URL Modifier"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateSchool("LoginPath", e.target.value)}
                            />
                          </GridItem>
                        </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveSchool();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

SchoolEditor = connect(mapStateToProps)(SchoolEditor);
export default withStyles(modalStyle)(SchoolEditor);


// WEBPACK FOOTER //
// ./src/components/SchoolEditor/SchoolEditor.jsx